import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserApi } from '../../services/ApiService';
import './Settings.css';

function InviteUserPage() {
  const [form, setForm] = useState({ email: '', firstName: '', lastName: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const isValidEmail = (e) => /\S+@\S+\.\S+/.test(e);
  const canSubmit = form.email && isValidEmail(form.email) && form.firstName && form.lastName && !loading;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleInvite = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await UserApi.sendInvitation({
        email: form.email.trim(),
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed with status ${res.status}`);
      }
      setSuccess('Invitation sent successfully.');
      setForm({ email: '', firstName: '', lastName: '' });
    } catch (err) {
      setError(err.message || 'Failed to send invitation.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page-content">
      <div className="settings-page-header">
        <h2>Invite User</h2>
        <Link className="btn btn-secondary" to="/settings/users">Back to Users</Link>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      <form onSubmit={handleInvite}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="user@example.com"
            required
          />
          {!form.email || isValidEmail(form.email) ? null : (
            <small>Enter a valid email address.</small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="firstName">First name</label>
          <input
            id="firstName"
            name="firstName"
            type="text"
            value={form.firstName}
            onChange={handleChange}
            placeholder="First name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Last name</label>
          <input
            id="lastName"
            name="lastName"
            type="text"
            value={form.lastName}
            onChange={handleChange}
            placeholder="Last name"
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" disabled={!canSubmit}>
            {loading ? 'Inviting…' : 'Invite'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => setForm({ email: '', firstName: '', lastName: '' })} disabled={loading}>
            Clear
          </button>
        </div>
      </form>

      <div className="info-panel">
        <h4>About Invitations</h4>
        <p>We’ll email the user an invitation link to join your organization.</p>
      </div>
    </div>
  );
}

export default InviteUserPage;